import React, { createContext, useContext, useMemo, useState } from 'react';

const AppContext = createContext({});

export const AppProvider = props => {
    const [loading, setLoading] = useState(false);
    const [isOffline] = useState(false);

    const value = useMemo(
        () => ({
            loading,
            setLoading,
            isOffline,
        }),
        [loading, isOffline],
    );

    return (
        <AppContext.Provider value={value}>
            {props.children}
        </AppContext.Provider>
    );
};

export const useApp = () => {
    const context = useContext(AppContext);
    if (!context) throw 'useApp context inside corret provider';

    return context;
};

 